<template>
  <b-modal
    id="bv-modal-add-linked-archives"
    title="Добавить старт в архив"
    hide-footer
  >
    <div v-if="availableArchives.length">
      <b-list-group>
        <b-list-group-item
          v-for="archive in availableArchives"
          :key="archive.id"
          class="d-flex justify-content-between align-items-center"
        >
          <div>
            <h6 class="mb-1">
              {{ archive.name }}
            </h6>
            <small
              v-if="archive.description"
              class="text-muted"
            >{{ archive.description }}</small>
          </div>
          <div>
            <b-badge
              variant="info"
              class="mr-2"
            >
              {{ (archive.starts || []).length }} старт(ов)
            </b-badge>
            <b-button
              size="sm"
              variant="primary"
              @click="addToArchive(archive)"
            >
              Добавить
            </b-button>
          </div>
        </b-list-group-item>
      </b-list-group>
    </div>

    <div
      v-else
      class="text-center text-muted"
    >
      Нет доступных архивов или старт уже добавлен во все архивы
    </div>
  </b-modal>
</template>

<script>
import {
  BModal, BListGroup, BListGroupItem, BButton, BBadge,
} from 'bootstrap-vue'

export default {
  name: 'DistanceModalAddLinkedArchives',
  components: {
    BModal, BListGroup, BListGroupItem, BButton, BBadge,
  },
  props: {
    allArchives: {
      type: Array,
      default: () => [],
    },
    startId: {
      type: Number,
      required: true,
    },
  },
  computed: {
    availableArchives() {
      return (this.allArchives || []).filter(
        archive => !(archive.starts || []).some(s => Number(s.id) === Number(this.startId)),
      )
    },
  },
  methods: {
    async addToArchive(archive) {
      try {
        const startIds = [...(archive.starts || []).map(s => s.id), this.startId]
        const payload = {
          name: archive.name,
          description: archive.description || '',
          startIds,
        }

        await this.$http.put('start/start-archive/change-archive', payload, {
          params: { id: archive.id },
        })

        this.$bvToast.toast(`Старт успешно добавлен в архив "${archive.name}"`, {
          title: 'Успешно',
          variant: 'success',
          solid: true,
        })
        this.$emit('archive-added')
        this.$bvModal.hide('bv-modal-add-linked-archives')
      } catch (error) {
        console.error('Ошибка при добавлении старта в архив:', error)
        this.$bvToast.toast('Ошибка при добавлении старта в архив', {
          title: 'Ошибка',
          variant: 'danger',
          solid: true,
        })
      }
    },
  },
}
</script>

<style scoped>
.list-group-item:focus {
  background-color: inherit !important;
  box-shadow: none !important;
  outline: none !important;
}
</style>
